import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContext';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useSiteContent();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};